export const DEFAULT_SUMMARY_TIMEFRAME_PRESET = "last-30";

export const SUMMARY_TIMEFRAME_PRESETS = [
  { id: "last-15", minutes: 15 },
  { id: "last-30", minutes: 30 },
  { id: "last-60", minutes: 60 },
  { id: "last-180", minutes: 180 },
  { id: "last-1440", minutes: 1440 },
  { id: "custom", custom: true }
];

function asDate(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function toDatetimeLocalValue(value) {
  const date = asDate(value);
  if (!date) {
    return "";
  }

  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  return localDate.toISOString().slice(0, 16);
}

export function getDefaultCustomTimeframe(now = new Date()) {
  const endDate = asDate(now) || new Date();
  const startDate = new Date(endDate.getTime() - 30 * 60 * 1000);
  return {
    from: toDatetimeLocalValue(startDate),
    to: toDatetimeLocalValue(endDate)
  };
}

export function buildSummaryTimeframe({
  presetId = DEFAULT_SUMMARY_TIMEFRAME_PRESET,
  customFrom,
  customTo,
  now = new Date()
} = {}) {
  const preset = SUMMARY_TIMEFRAME_PRESETS.find(item => item.id === presetId) || SUMMARY_TIMEFRAME_PRESETS[1];
  const endDate = asDate(now) || new Date();
  const fromDate = preset.custom ? asDate(customFrom) : new Date(endDate.getTime() - preset.minutes * 60 * 1000);
  const toDate = preset.custom ? asDate(customTo) : endDate;

  if (!fromDate || !toDate || toDate.getTime() <= fromDate.getTime() || toDate.getTime() > endDate.getTime()) {
    return {
      valid: false,
      presetId: preset.id,
      from: null,
      to: null
    };
  }

  return {
    valid: true,
    presetId: preset.id,
    from: fromDate.toISOString(),
    to: toDate.toISOString()
  };
}
